import React, { useContext } from "react";
import {
  Box,
  Flex,
  Drawer,
  DrawerBody,
  Icon,
  useColorModeValue,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  useDisclosure
} from "@chakra-ui/react";
import Content from "theme-components/sidebar/components/Content";
import {
  renderThumb,
  renderTrack,
  renderView,
} from "theme-components/scrollbar/Scrollbar";
import { Scrollbars } from "react-custom-scrollbars-2";
import PropTypes from "prop-types";
import { IoMenuOutline } from "react-icons/io5";
import { SidebarContext } from "contexts/SidebarContext";

function Sidebar(props) {
  const { routes } = props;

  const { toggleSidebar, setToggleSidebar } = useContext(SidebarContext); // Use context to get global state
  let variantChange = "0.2s linear";
  let shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.08)",
    "unset"
  );
  let sidebarBg = useColorModeValue("white", "navy.800");
  let sidebarMargins = "0px";

  const handleToggleSidebar = () => setToggleSidebar(!toggleSidebar);

  return (
    <>
      {/* Toggle Button */}
      <Button
        display={{ sm: "none", xl: "block" }}
        position="fixed"
        top="40px"
        left={toggleSidebar ? "230px" : "20px"}
        zIndex="999"
        onClick={handleToggleSidebar}
      >
        <Icon as={IoMenuOutline} w="20px" h="20px" />
      </Button>

      {/* Sidebar */}
      {toggleSidebar && (
        <Box
          display={{ sm: "none", xl: "block" }}
          w="100%"
          position="fixed"
          minH="100%"
        >
          <Box
            bg={sidebarBg}
            transition={variantChange}
            w="300px"
            h="100vh"
            m={sidebarMargins}
            minH="100%"
            overflowX="hidden"
            boxShadow={shadow}
          >
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Content routes={routes} />
            </Scrollbars>
          </Box>
        </Box>
      )}
    </>
  );
}

export function SidebarResponsive(props) {
  let sidebarBackgroundColor = useColorModeValue("white", "navy.800");
  let menuColor = useColorModeValue("gray.400", "white");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const { routes } = props;

  return (
    <Flex display={{ sm: "flex", xl: "none" }} alignItems="center">
      {/* Menu Button */}
      <Flex ref={btnRef} w="max-content" h="max-content" onClick={onOpen}>
        <Icon
          as={IoMenuOutline}
          color={menuColor}
          my="auto"
          w="20px"
          h="20px"
          me="10px"
          _hover={{ cursor: "pointer" }}
        />
      </Flex>
      {/* Mobile Sidebar Drawer */}
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent w="285px" maxW="285px" bg={sidebarBackgroundColor}>
          <DrawerCloseButton
            zIndex="3"
            onClose={onClose}
            _focus={{ boxShadow: "none" }}
            _hover={{ boxShadow: "none" }}
          />
          <DrawerBody maxW="285px" px="0rem" pb="0">
            <Scrollbars
              autoHide
              renderTrackVertical={renderTrack}
              renderThumbVertical={renderThumb}
              renderView={renderView}
            >
              <Content routes={routes} />
            </Scrollbars>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}

// PROPS
Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};

export default Sidebar;
